import type { HTMLAttributes } from 'react';
import { cn } from './cn.js';

export function Skeleton({ className, ...rest }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      {...rest}
      className={cn(
        'shimmer animate-shimmer rounded-xl bg-raise',
        className,
      )}
    />
  );
}

export function SkeletonList({ count = 4, className }: { count?: number; className?: string }) {
  return (
    <div className={cn('space-y-2.5', className)}>
      {Array.from({ length: count }).map((_, i) => (
        <Skeleton key={i} className="h-[72px]" />
      ))}
    </div>
  );
}
